<template>
	
<core-card-foot-date :value="value" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return this.item.rating.date

		}

	}

}

</script>

<style scoped>

</style>
